module.exports = __webpack_public_path__ + "static/media/quote-roosevelt-right-thing-fr.06ad7392.png";